import AnalyticsWebClient, { envType } from '@atlassiansox/analytics-web-client';
import { BrowserClient, defaultIntegrations, defaultStackParser, makeFetchTransport } from '@sentry/browser';
import { isFedRamp } from '@atlassian/atl-context';
export var envTypes = /*#__PURE__*/function (envTypes) {
  envTypes["LOCAL"] = "local";
  envTypes["PROD"] = "prod";
  envTypes["STAGING"] = "staging";
  envTypes["DEV"] = "dev";
  return envTypes;
}({});
export var getSentryEnv = function getSentryEnv() {
  var microsEnv = process.env.MICROS_ENV;
  if (microsEnv === undefined) {
    return envTypes.LOCAL;
  }
  if (microsEnv.includes('prod')) {
    return envTypes.PROD;
  }
  if (microsEnv.includes('stg')) {
    return envTypes.STAGING;
  }
  if (microsEnv.includes('dev')) {
    return envTypes.DEV;
  }
  // Might not be prod but better to be paged about than not
  return envTypes.PROD;
};
var sentryClient;
export var createSentryClient = function createSentryClient() {
  if (sentryClient === undefined) {
    sentryClient = new BrowserClient({
      // See: https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/1436386358/Sentry+Cloud+-+Getting+Started
      // Commerce is out of scope for fedramp. This is a temporary measure to ensure compatibility in the case
      // consumers utilise the library in a fedramp environment. These metrics are seldomly looked and thus will be
      // omitted in a fedramp environment.
      dsn: isFedRamp() ? undefined : 'https://1d1cdcd18d1541f0b770a1b9ed74335f@o55978.ingest.sentry.io/5988896',
      environment: getSentryEnv(),
      integrations: defaultIntegrations,
      transport: makeFetchTransport,
      stackParser: defaultStackParser
    });
  }
  return sentryClient;
};
export var getAnalyticsEnv = function getAnalyticsEnv() {
  var microsEnv = process.env.MICROS_ENV;
  if (microsEnv === undefined) {
    return envType.LOCAL;
  }
  if (microsEnv.includes('prod')) {
    return envType.PROD;
  }
  if (microsEnv.includes('stg')) {
    return envType.STAGING;
  }
  if (microsEnv.includes('dev')) {
    return envType.DEV;
  }
  // Might not be LOCAL but best not polute guaranteed prod analytics
  return envType.LOCAL;
};
var analyticsWebClient;
export var createAnalyticsClient = function createAnalyticsClient() {
  if (analyticsWebClient === undefined) {
    analyticsWebClient = new AnalyticsWebClient({
      env: getAnalyticsEnv(),
      product: 'commerce-libraries',
      subproduct: 'commerce-libraries',
      version: '1.0.0',
      locale: 'en-US'
    });
  }
  return analyticsWebClient;
};